<template>
  <div>
    <v-layout>
      <v-flex xs12 style="position:relative">
        <v-text-field v-if="editable" v-model="model" :landscape="true"></v-text-field>
        <div v-else>

          <v-tooltip top>
            <template v-slot:activator=" { on }">
              <span ref="span" v-on="on">{{ getPresentationValue(model) | notEmpty }}</span>
            </template>
            <span>{{ model }}</span>
            <div v-if="!isBaseValid()">{{ validation.message }}</div>
          </v-tooltip>

        </div>
        <v-icon style="position:absolute;top:5px;right:-30px;cursor:pointer;z-index:2000" @click="updateOrigin" v-if="isEdited() && editable" class="light-green--text">check</v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import moment from 'moment/moment'
import precise from 'moment-precise-range-plugin/moment-precise-range'

export default {
  props: ["valueField", "editable", "field", "validation", "context"],
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      modelx: "",
      valueToShow: ""
    }
  },
  methods: {
    isBaseValid() {
      if (this.field.options && this.field.options.expanded)
        return false;
      return this.validation.pass
    },
    setUpModel(value) {
      return value
    },
    updateOrigin() {
      this.$emit("updateField", this.model)
    },
    isEdited() {
      return this.valueField != this.model
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getPresentationValue(model) {
      if (this.field.options && this.field.options.showTimePassed){

        if(!model){
          return ''
        }

        let date = new moment(model)
        let diff = moment.preciseDiff(date, new moment(),true)
        return `${diff.years} lat ${diff.months} miesiecy ${diff.days} dni`
      }
      return model;
    },
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  mixins: [input]
}
</script>
